module.exports = __webpack_public_path__ + "assets/7de4a85ee2c7979b3df4b50e14c0145d.png";